import * as React from 'react';
import { Box } from '../../CommonUI/Layout';
import { css, StyleSheet } from 'aphrodite';
import { Text as T } from 'ilenia';
import { BusinessUser, InvitationsSettings, EmailImageType, EmailSentFrom, EmailType } from '../../Model';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as actions from '../../Actions/emailExample';
import * as tracking from '../../Actions/analytics';

interface EmailExampleProps {
    source: string;
    tierName: string;
    businessUser: BusinessUser;
    shop?: string;
    businessUnitId: string;
    invitationSettings?: InvitationsSettings;
    testInvitationSentPastOrders: boolean;
    testInvitationSentProductReviews: boolean;
    sendEmail?: (data: any, sentFrom: EmailSentFrom) => void;
    track: (name: string, data: any) => void;
    imageType?: EmailImageType;
    style?: any;
    sentFrom: EmailSentFrom;
    templateType: EmailType;
}

class EmailExample extends React.Component<EmailExampleProps> {
    constructor(props: EmailExampleProps) {
        super(props);
        this.onExampleLinkClick = this.onExampleLinkClick.bind(this);
        this.checkIsInvitationSent = this.checkIsInvitationSent.bind(this);
    }

    public onExampleLinkClick() {
        const { businessUnitId, invitationSettings, sendEmail, track, sentFrom, templateType } = this.props;
        if (this.checkIsInvitationSent()) { return; }
        const { tierName, businessUser, shop } = this.props;
        track('Integration Link Clicked', {
            context: 'Ecommscript integration app',
            location: window.location.pathname,
            placement: 'Under invitation example image',
            action: `Send test invitation`,
            name: `send-test-invitation`,
        });
        sendEmail!({
            businessUnitId,
            recipientName: businessUser.name,
            tierName,
            templateId: templateType === EmailType.ServiceReviews ? invitationSettings!.templateId : invitationSettings!.productReviewInvitationTemplateId,
            domainName: shop || 'example.com',
        }, sentFrom);
    }

    public checkIsInvitationSent() {
        const { testInvitationSentPastOrders, testInvitationSentProductReviews, sentFrom } = this.props;

        if (testInvitationSentPastOrders && sentFrom === EmailSentFrom.PastOrders) {
            return true;
        }

        if (testInvitationSentProductReviews && sentFrom === EmailSentFrom.ProductReviews) {
            return true;
        }

        return false;
    }

    public render() {
        const { businessUser, style, imageType } = this.props;
        const emailImageUrl = imageType === EmailImageType.PastOrders
            ? require('../../Assets/images/email-template.png')
            : require('../../Assets/images/group.png');
        return (
            <Box className={css(styles.exampleBox, style)}>
                <div className={css(styles.exampleTitle)}><T id="ProductReviews.example.title"/></div>
                <img className={css(styles.exampleImage)} src={emailImageUrl}/>
                <div
                    className={css(styles.exampleLink, this.checkIsInvitationSent() && styles.exampleLinkClicked)}
                    onClick={this.onExampleLinkClick}
                >
                    { this.checkIsInvitationSent() ?
                        <div><T id="ProductReviews.example.invitationSent"/> {businessUser.email}</div> :
                        <div><T id="ProductReviews.example.link"/> {businessUser.email}</div>
                    }
                </div>
            </Box>
        );
    }
}

const mapStateToProps = (state: any) => ({
    testInvitationSentPastOrders: state.emailExample.testInvitationSentPastOrders,
    testInvitationSentProductReviews: state.emailExample.testInvitationSentProductReviews,
    businessUnitId: state.App.account.businessUnitId,
    businessUser: state.App.account.businessUser,
    integrationKey: state.App.integrationKey,
    source: state.App.source,
    tierName: state.App.tierName,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendEmail: (data: any, sentFrom: EmailSentFrom) =>
        dispatch(actions.sendEmail(data, sentFrom)),
    track: (name: string, data: any) =>
        dispatch(tracking.track(name, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailExample);

const styles = StyleSheet.create({
    exampleBox: {
        maxWidth: '558px',
        background: 'rgb(253, 253, 253)',
        borderRadius: '4px',
        border: '1px solid rgb(223, 226, 229)',
        padding: '32px 70px',
        height: '100%',
        marginTop: 0,
        borderTop: 'none',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    exampleImage: {
        width: '100%',
    },
    exampleTitle: {
        color: 'rgb(169, 169, 169)',
        fontSize: '14px',
        fontWeight: 'normal',
        height: '17px',
        letterSpacing: '0px',
        textAlign: 'center',
        margin: '0 auto 16px',
    },
    exampleLink: {
        color: 'rgb(74, 144, 226)',
        fontSize: '14px',
        letterSpacing: '0px',
        textAlign: 'center',
        margin: '24px auto 0',
        cursor: 'pointer',
    },
    exampleLinkClicked: {
        color: 'rgb(0, 182, 122)',
        cursor: 'not-allowed',
    },
});
